import { ArgumentAxis, Chart, ChartProps, Tooltip, ValueAxis } from "@devexpress/dx-react-chart-material-ui";
import { Animation, EventTracker, HoverState, LineSeries, Stack } from "@devexpress/dx-react-chart";
import { useTheme } from "@mui/material";
// @ts-ignore
import { curveCatmullRom, line } from "d3-shape";
import { formatPrice } from "helpers/dataFormat";
import { useEffect, useState } from "react";

const Line = (props: any) => (
  // @ts-ignore
  <LineSeries.Path
    {...props}
    style={{ strokeWidth: 3 }}
    path={line()
      .x(({ arg }: any) => arg)
      .y(({ val }: any) => val)
      .curve(curveCatmullRom)}
  />
);

const adjustWindowData = (data: LineChartDataType) => {
  try {
    const outPut = data.map((item) => ({
      title: item.title,
      value: item.value,
      adjusted: item.value,
    }));

    const min = data.reduce(function (prev, curr) {
      return prev.value < curr.value ? prev : curr;
    });
    const max = data.reduce(function (prev, curr) {
      return prev.value > curr.value ? prev : curr;
    });
    outPut[0] = {
      title: data[0].title,
      value: data[0].value,
      adjusted: min.value - (max.value - min.value) / 5,
    };

    outPut[data.length - 1] = {
      title: data[data.length - 1].title,
      adjusted: max.value + (max.value - min.value) / 5,
      value: data[data.length - 1].value,
    };

    return outPut;
  } catch {
    return [];
  }
};

const LineChart = ({
  height,
  data,
  selectOption,
}: {
  height?: number;
  data: LineChartDataType;
  selectOption?: string;
}) => {
  const [rendered, setRendered] = useState(false);
  const ChartWithChildren = Chart as React.ComponentType<ChartProps & { children: React.ReactNode }>;

  const [chartData, setChartData] = useState(adjustWindowData(data));

  useEffect(() => {
    setChartData(adjustWindowData(data));
  }, [data]);

  const {
    palette: {
      primary: { main },
    },
  } = useTheme();

  const [hover, setHover] = useState(undefined);
  const [selection, setSection] = useState(undefined);

  const clickItem = ({ targets }: any) => {
    const target = targets[0];
    if (target) {
      setSection(targets);
    }
  };

  const changeHover = (hover: any) => {
    hover?.series === "Value" && setHover(hover);
  };

  const renderTooltip = (props: any, data: any) => {
    data = props.targetItem ? data[props.targetItem.point] : null;
    return (
      <div style={{ direction: "rtl" }}>
        <div>{data.title}</div>
        {data?.value && <div style={{ marginTop: "4px" }}>{formatPrice(data.value)}</div>}
      </div>
    );
  };

  const ArgumentLabel = (props: any, selectOption?: string) => {
    return <ArgumentAxis.Label {...props} text={selectOption === "lastMonth" ? "" : props.text} />;
  };

  return (
    <div style={{ direction: "ltr" }}>
      <ChartWithChildren data={chartData} height={height || 350}>
        <ArgumentAxis labelComponent={(props) => ArgumentLabel(props, selectOption)} />
        <ValueAxis showGrid={false} />
        <LineSeries
          name="Adjusted"
          valueField="adjusted"
          argumentField="title"
          color="#ffffff0"
          seriesComponent={Line}
        />
        <LineSeries
          name="Value"
          valueField="value"
          argumentField="title"
          color={main}
          seriesComponent={Line}
        />
        {/*<Animation />*/}
        <EventTracker onClick={clickItem} />
        <HoverState hover={hover} onHoverChange={changeHover} />
        <Tooltip targetItem={hover} contentComponent={(props) => renderTooltip(props, data)} />
        <Stack
          stacks={[
            {
              series: ["Value", "Adjusted"],
            },
          ]}
        />
      </ChartWithChildren>
    </div>
  );
};

export default LineChart;
